import { GeneratedQrCodesDTO } from './../../../../../base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { Injectable } from '@angular/core';
import { ZoneClient, ZoneQrCodeInfosDTO } from 'src/app/base/models/models.swagger.generated';
import { Observable, catchError, of, tap } from 'rxjs';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class GenerateQrCodeDetailsService {

  constructor(private zoneClient: ZoneClient,
              private spinnerService: SpinnerService,
              private toastService: ToastService) { }

  public generateQrCode(zoneId: number, isStickerMode: boolean, parkingSpaceNumberDefinition: string): Observable<GeneratedQrCodesDTO> {
    this.spinnerService.show();
    var qrCodeDto = new ZoneQrCodeInfosDTO({
      zoneId: zoneId,
      isStickerMode: isStickerMode,
      parkingSpaceNumbers: parkingSpaceNumberDefinition
    });
    return this.zoneClient.generateQrCode(qrCodeDto)
      .pipe(
        tap(() => {
          this.spinnerService.hide();
          this.toastService.showSuccess(
            'i18n.domain.administration.generate-qr-code-dialog.success-title',
            'i18n.domain.administration.generate-qr-code-dialog.success-description'
          );
        }),
        catchError((error: any) => {
          this.spinnerService.hide();
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return of(error);
        })
      );
  }
}
